import './style.scss';


export default function OnboardingPopup (props) {
    return(
        <div className={`onboarding-popus-root ${props.className || ''}`} style={{
            ...props.style,
            width: props.width, height: props.height
        }}>
            {props.topLeftOutImage &&
            <img src={props.topLeftOutImage} className='top-left-out-image' />}
            {props.title && <div className="title mb-12">
                {props.title}
            </div>}
            <div className="description" style={{color: props.descriptionColor || '#161617'}}>
                {props.description || 'Lprem Ispum Dolor ... ... ...'}
            </div>
            <div className="ctas">
                {props.children}
            </div>
        </div>
    )
}

// props
/**
 * width = px
 * height px / fit-content
 * className
 * style = {{}}
 */